import { useLang } from '@/i18n';
import EcoTextTc from 'eco-design/sections/eco-text-tc';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.FooterTcA');
    const items = [
        // {
        //     isHead: true,
        //     title: t('head1'),
        // },
        {
            title: t('titleA1'),
        },

        {
            title: `
                    *2: Alternator Chargerの取り付け方法については、EcoFlowが提供する取扱説明書<a href="https://cdn.shopify.com/s/files/1/0412/3459/6001/files/EcoFlow_800W_Alternator_Charger___JP_20240613.pdf?v=1718260875">（https://cdn.shopify.com/s/files/1/0412/3459/6001/files/EcoFlow_800W_Alternator_Charger___JP_20240613.pdf?v=1718260875）</a>または解説動画<a href="https://www.youtube.com/watch?v=rEXKWHAY1U8">（https://www.youtube.com/watch?v=rEXKWHAY1U8）</a>をご参照ください。配線作業については、ご購入前に専門業者にご相談いただくことを推奨します。本製品を誤って使用した場合、重大な事故やケガ、車両や本製品の損傷の原因となる恐れがあります。ご使用前に再度解説動画や取扱説明書を参照の上、正しい使用法を理解し、正しく取り付けられていることを十分にご確認ください。本製品の使用に際し、お客様はここに記載された利用規約の内容を全て理解、承認、承諾したものとみなされます。EcoFlowは、当社から提供されている各種ガイドラインに従って本製品を使用しなかったことによって生じた損失に対して、一切の責任を負いません。当社は、法令の遵守に基づき、本製品の最終的な解釈権を留保します。
            `,
        },
        {
            title: t('descA2'),
        },
    ];
    return (
        <>
            <EcoTextTc items={items} className={styles.comp} />
        </>
    );
}
